import React, { memo } from 'react';

import {
  getChannelDisplayName,
  getChannelMembers,
  getMessageSender,
  getMessageText,
} from 'app/shared/components/TeamChat/TeamChat.utils';
import PropTypes from 'prop-types';

import HeaderChatInboxRow from '../../../HeaderChatInboxRow';
import { formatMentionTimestamp, truncatePreview } from '../../HeaderChatMentionsList.utils';

const HeaderChatMentionRow = memo(
  ({ chatId, messageId = null, channel, message, timestamp, onSelect }) => {
    const channelName = getChannelDisplayName(channel) || 'Conversation';
    const members = getChannelMembers(channel);
    const sender = getMessageSender(message, members);
    const preview = truncatePreview(getMessageText(message));
    const displayTimestamp = formatMentionTimestamp(timestamp);

    return (
      <HeaderChatInboxRow
        unread
        channelName={channelName}
        dataChatId={chatId}
        dataMessageId={messageId}
        preview={preview}
        senderName={sender.nickname || null}
        timestamp={displayTimestamp}
        onSelect={onSelect}
      />
    );
  },
);

HeaderChatMentionRow.propTypes = {
  chatId: PropTypes.string.isRequired,
  message: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  channel: PropTypes.object,
  messageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  timestamp: PropTypes.string,
};

export default HeaderChatMentionRow;
